(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CustomTabs"] && !window.DesignMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Rich-Rebecca"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Initialize animations
  const textBlocks = document.querySelectorAll('.text-block');
  textBlocks.forEach(block => {
    block.classList.add('fade-in');
  });

  // Handle button touch events
  const buttons = document.querySelectorAll('.button');
  buttons.forEach(button => {
    button.addEventListener('touchstart', function() {
      this.style.opacity = '0.8';
    });
    button.addEventListener('touchend', function() {
      this.style.opacity = '1';
    });
  });

  // Function to download a file then open Seguno form
  window.downloadThenOpenSeguno = function(downloadUrl, filename, formId) {
    // First initiate the download
    fetch(downloadUrl)
      .then(response => response.blob())
      .then(blob => {
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        // Wait a moment to ensure download starts, then open Seguno form
        setTimeout(() => {
          openSeguroForm(formId);
        }, 500);
      })
      .catch(err => {
        console.error('Failed to download file: ', err);
        // Fallback method if fetch fails
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = filename;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        
        // Still open the Seguno form
        setTimeout(() => {
          openSeguroForm(formId);
        }, 500);
      });
  };

  // Function to open Seguno form
  window.openSeguroForm = function(formId) {
    // Check if Seguno is loaded
    if (window.Seguno && window.Seguno.forms) {
      // Open the Seguno form with the provided ID
      window.Seguno.forms.popup(formId);
    } else {
      console.error('Seguno not found or not fully loaded');
      
      // Fallback: If Seguno isn't loaded yet, try to load it
      const script = document.createElement('script');
      script.src = 'https://cdn.seguno.com/sdk/forms.js';
      script.onload = function() {
        // Once loaded, try to open the form
        if (window.Seguno && window.Seguno.forms) {
          window.Seguno.forms.popup(formId);
        } else {
          console.error('Could not load Seguno forms SDK');
        }
      };
      document.head.appendChild(script);
    }
  };

  // Function to force download a file from a URL
  window.forceDownload = function(url, filename) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(err => {
        console.error('Failed to download file: ', err);
        // Fallback method if fetch fails
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
  };
  
  // Function to force download a file and then show email collection popup
  window.forceDownloadThenCollectEmail = function(url, filename, buttonType) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(a);
        
        // Show popup after download starts
        setTimeout(() => {
          document.getElementById('downloadType').value = buttonType;
          document.getElementById('emailPopupOverlay').classList.add('active');
        }, 500);
      })
      .catch(err => {
        console.error('Failed to download file: ', err);
        // Fallback method if fetch fails
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        
        // Show popup after attempted download
        setTimeout(() => {
          document.getElementById('downloadType').value = buttonType;
          document.getElementById('emailPopupOverlay').classList.add('active');
        }, 500);
      });
  };
  
  // Close popup function
  window.closeEmailPopup = function() {
    document.getElementById('emailPopupOverlay').classList.remove('active');
  };
  
  // Handle form submission
  if (document.getElementById('downloadEmailForm')) {
    document.getElementById('downloadEmailForm').addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = document.getElementById('downloadEmail').value;
      const downloadType = document.getElementById('downloadType').value;
      
      // Save email to your database or service and add the "veteran" tag
      console.log('Saving email:', email, 'with tag: veteran');
      
      fetch('/apps/email-collector', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: email,
          tags: ['veteran'],
          source: 'download-' + downloadType
        }),
      })
      .then(response => response.json())
      .then(data => {
        console.log('Email saved:', data);
      })
      .catch((error) => {
        console.error('Error saving email:', error);
      });
      
      // Close popup
      closeEmailPopup();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const stories = document.querySelectorAll('.video-story');
  const lightbox = document.querySelector('.video-lightbox');
  const lightboxPlayer = lightbox.querySelector('.video-lightbox__player');
  const closeButton = lightbox.querySelector('.video-lightbox__close');
  
  stories.forEach(story => {
    story.addEventListener('click', () => {
      const videoSource = story.dataset.videoSource;
      const videoUrl = story.dataset.videoUrl;
      
      let player;
      
      if (videoSource === 'youtube') {
        player = `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoUrl}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      } else {
        player = `<video width="100%" height="100%" controls autoplay playsinline>
          <source src="${videoUrl}" type="${story.dataset.videoMime}">
          Your browser does not support the video tag.
        </video>`;
      }
      
      lightboxPlayer.innerHTML = player;
      lightbox.classList.add('is-active');
      
      // Auto-play the video
      const videoElement = lightboxPlayer.querySelector('video');
      if (videoElement) {
        videoElement.play().catch(function(error) {
          console.log("Video play failed:", error);
        });
      }
    });
  });
  
  const closeVideo = () => {
    const videoElement = lightboxPlayer.querySelector('video');
    if (videoElement) {
      videoElement.pause();
      videoElement.currentTime = 0;
    }
    lightboxPlayer.innerHTML = '';
    lightbox.classList.remove('is-active');
  };
  
  closeButton.addEventListener('click', closeVideo);
  
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      closeVideo();
    }
  });
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.classList.contains('is-active')) {
      closeVideo();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
